"use client";

// ============================================================
// CLUBHUB – Kopfzeile (wie im Agent: gehoert der Anwendung)
// ============================================================
// Volle Breite, ganz oben, Glas. Links Burger (Telefon), Verein und
// Bereich, rechts Suche, Benachrichtigungen, Hell/Dunkel, Einstellungen.
// ============================================================
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Bell, Search, Settings } from "lucide-react";
import { bereichFuer } from "@/lib/navigation";
import { ThemeSwitch } from "./theme-switch";
import { ClubSwitch } from "./club-switch";
import { MobileNav } from "./mobile-nav";
import type { ClubView, UserView } from "@/lib/views";

const KNOPF =
  "text-text-secondary hover:bg-bg-secondary hover:text-text-primary duration-fast grid h-9 w-9 place-items-center rounded-lg transition-colors";

export function Topbar({
  club,
  clubs,
  user,
  onSuche,
}: {
  club: ClubView;
  clubs: ClubView[];
  user: UserView;
  onSuche: () => void;
}) {
  const pathname = usePathname();
  const bereich = bereichFuer(pathname);

  return (
    <header className="glass h-topbar shadow-e1 sticky top-0 z-40 flex shrink-0 items-center justify-between gap-3 px-3 sm:px-5">
      <div className="flex min-w-0 items-center gap-2 lg:gap-4">
        <MobileNav club={club} user={user} />
        <ClubSwitch club={club} clubs={clubs} />
        {bereich && (
          <div className="hidden min-w-0 items-center gap-4 sm:flex">
            <span aria-hidden className="bg-border h-5 w-px shrink-0" />
            <h1 className="text-heading-sm text-text-primary truncate">{bereich.label}</h1>
          </div>
        )}
      </div>

      <div className="flex shrink-0 items-center gap-1">
        <button
          type="button"
          onClick={onSuche}
          className="border-border bg-bg-primary/60 text-body-sm text-text-tertiary hover:border-border-strong hover:text-text-secondary duration-fast mr-1 hidden h-9 items-center gap-2 rounded-lg border px-3 transition-colors md:flex"
        >
          <Search className="h-4 w-4" aria-hidden />
          <span className="w-40 text-left lg:w-56">Suchen …</span>
          <kbd className="text-caption border-border rounded border px-1.5 py-px">⌘K</kbd>
        </button>
        <button type="button" onClick={onSuche} aria-label="Suchen" className={`${KNOPF} md:hidden`}>
          <Search className="h-4 w-4" aria-hidden />
        </button>
        <button type="button" aria-label="Benachrichtigungen" className={`${KNOPF} relative`}>
          <Bell className="h-4 w-4" aria-hidden />
          <span aria-hidden className="bg-accent absolute top-2 right-2 h-1.5 w-1.5 rounded-full" />
        </button>
        <ThemeSwitch className="max-md:hidden" />
        <Link href="/einstellungen" aria-label="Einstellungen" className={`${KNOPF} max-md:hidden`}>
          <Settings className="h-4 w-4" aria-hidden />
        </Link>
      </div>
    </header>
  );
}
